import { Fragment, type FC } from "react"
import {
  Box,
  Link,
  Stack
} from "@mui/material"
import EllipsisTypography from "../../atoms/customTypography/EllipsisTypography"
import { TruncatedTooltip } from "../../atoms/tooltip/Tooltip"
import { getDeliverableExtension, iconMap } from "../../../../helpers/getIconFileExtension"
import { ReactSVG } from "react-svg"
import { formatDateFromIsoStringToDateAsDDabrMMYYYY } from "../../../../helpers/formatDates"
import { MarkAsReadAction} from "../../../../types/NotificationsModel"
import { navigateToUrl } from "single-spa"

type Props = {
  title: string,
  documentName: string,
  date: string,
  documentURL: string,
  read: boolean
  icon: string
  strictlyConfidential: boolean
  notificationId: string
  onAction: MarkAsReadAction
}

const NotificationCard: FC<Props> = (props) => {

  const { title, documentName, date, read, icon, strictlyConfidential, documentURL, notificationId, onAction } = props

  const handleClick = async (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const href = e.currentTarget.href;
      await onAction(notificationId, read);
    navigateToUrl(href);

  }

  return (
    <Fragment>
      <Stack
        sx={{
          padding: '0px 16px 0px 0px',
          height: '22px',
          alignSelf: 'stretch',
          fontSize: '12px',
          fontWeight: 'normal',
          fontStretch: 'normal',
          fontStyle: 'normal',
          lineHeight: '1.83',
          letterSpacing: 'normal',
          textAlign: 'left',
          color: '#595958'
        }}
      > 
        <EllipsisTypography
          text={title}
          lines={1}
          fontSize={12}
          tooltipComponent={TruncatedTooltip}
          sx={{ height: "100%", fontWeight: 'normal' }}
        ></EllipsisTypography>
      </Stack>
      <Stack
        sx={{
          padding: '5px 16px 0px 0px',
          flexGrow: '1',
        }}
      >
        <Link href={documentURL} onClick={handleClick}
          sx={{ textTransform: "none", display: "flex", alignItems: "center", textDecoration: 'none' }}
        >
          <Box sx={{ display: "flex", overflow: "hidden" }}>
            <Box sx={{ flexShrink: 0, mr: "6px", paddingLeft:"5px", maxHeight: "20px" }}>
                {strictlyConfidential ? (
                    <ReactSVG width={"14px"} height={"14px"} display={"flex"}
                      src={
                        icon ===
                          "dashboard"
                          ? "/icons/file-icons/Dashboard-confidential.svg"
                          : icon ===
                            "web"
                            ? "/icons/file-icons/Web-report-confidential.svg"
                            : `/icons${iconMap[
                            getDeliverableExtension(
                              icon ||
                              "",
                            )
                            ]
                            }-confidential.svg`
                      }
                    />
                ) : (
                  <ReactSVG
                    src={
                      icon === "dashboard"
                        ? "/icons/file-icons/Dashboard.svg"
                        : icon === "web"
                          ? "/icons/file-icons/Web-report.svg"
                          : `/icons${iconMap[
                          getDeliverableExtension(
                            icon || "",
                          )
                          ]
                          }.svg`
                    }
                  />
                )}
            </Box>
            <EllipsisTypography
              text={documentName}
              lines={1}
              fontSize={14}
              tooltipComponent={TruncatedTooltip}
              sx={{ height: "100%", fontWeight: read == false ? '600' : 'normal', color: '#242D35' }}
            ></EllipsisTypography>
          </Box>
        </Link>
      </Stack>
      <Stack
        sx={{
          padding: '5px 16px 0px 0px',
          alignSelf: 'stretch',
          flexGrow: '0',
          fontSize: '12px',
          fontWeight: 'normal',
          fontStretch: 'normal',
          fontStyle: 'normal',
          lineHeight: '1.83',
          letterSpacing: 'normal',
          textAlign: 'left',
          color: '#595958',

        }}
      > {formatDateFromIsoStringToDateAsDDabrMMYYYY(date)}
      </Stack>
    </Fragment>
  )
}

export default NotificationCard
